import { Injectable } from '@angular/core';
import { ExperimentCreateImportDatasetComponent } from '@app/components/experiment-create-import-dataset/experiment-create-import-dataset.component';
import { ExperimentCreateDetailsComponent } from '@components/experiment-create-details/experiment-create-details.component';

@Injectable({
  providedIn: 'root'
})
export class ExperimentCreateService {

  constructor() { }

  getStages(): Record<string, any> {
    return {
      details: {
        component: ExperimentCreateDetailsComponent,
      },
      "import-dataset": {
        component: ExperimentCreateImportDatasetComponent
      }
    }
  }
}
